<template>
	<div class="crud-form-group" :class="validationRules ?  getValidationClass() : ''">
		<CrudLabel
			:label="label"
			:hasCheckBox="hasCheckBox"
			:checkboxData="checkboxData"
			v-if="showLabel"
			@valueHasChanged="valueHasChanged"
			:subLabel="subLabel"
			:classList="classList"
		/>
		<input
			class="crud-input"
			:class="hasError ? 'has-error' : ''"
			:id="id"
			:type="type"
			:name="name"
			:placeholder="placeholder"
			aria-autocomplete="off"
			autocomplete="off"
			:aria-placeholder="placeholder"
			v-model="inputValue"
			:maxlength="validationRules.max"
			@focus="focusIn"
			@blur="focusOut"
			:ref="id"
		>
		<ErrorList :errors="errors" v-if="errors.length" />
	</div>
</template>
<script>
	import ErrorList from "./ErrorList.vue";
	import CrudLabel from "./CrudLabel.vue";
	import { CRUD_INPUT_PROPS } from "./props/CrudInputProps.js";
	import * as VALIDATION_SERVICE from "@/drc/services/validation.service.js";
	import {EventManagementContent, EventStepFrom} from "@/common/configurations/event-bus.js";

	export default {
		name: "CrudInput",
		components: {
			ErrorList,
			CrudLabel
		},
		props: {
			...CRUD_INPUT_PROPS
		},
		data() {
			return {
				seen: false,
				focused: false,
				errors: [],
				hasError: false,
			}
		},
		computed: {
			inputValue: {
				get() {
					return this.$props.value;
				},
				set(newValue) {
					this.valueHasChanged({
						fieldName: this.$props.name,
						value: newValue
					});
				}
			},
		},
		methods: {
			getValidationClass() {
				if (this.isManagementListener) {
					return 'auto-validate-mc';
				} else {
					return 'auto-validate';
				}
			},
			valueHasChanged(data) {

				this.$emit('valueHasChanged', data);
			},
			focusIn() {
				if (!this.seen) {
					this.seen = true;
				}

				this.focused = true;
			},
			focusOut() {
				this.focused = false;
				this.validateField();
			},
			validateField(hardCheck = false) {
				this.errors = [];
				if (this.seen && !this.focused && this.validationRules || hardCheck && this.validationRules) {

					if (this.type === 'text' || this.type === 'email') {
						if (this.validationRules.required && VALIDATION_SERVICE.validateRequired(this.inputValue)) {
							this.errors.push(this.$i18n.t('projectFormValidations.isRequired'));
						}

						if (this.validationRules.min && VALIDATION_SERVICE.validateMinStringLength(this.inputValue, this.validationRules.min)) {
							this.errors.push(this.$i18n.t('projectFormValidations.minString', {min: this.validationRules.min}));
						}

						if (this.validationRules.max && VALIDATION_SERVICE.validateMaxStringLength(this.inputValue, this.validationRules.max)) {
							this.errors.push(this.$i18n.t('projectFormValidations.maxString', {max: this.validationRules.max}));
						}

						if (this.validationRules.isLink && this.inputValue != '' && VALIDATION_SERVICE.validateLink(this.inputValue) === false) {
							this.errors.push(this.$i18n.t('projectFormValidations.urlValid'));
						}

					}

					if (this.type === 'email' && this.inputValue && !VALIDATION_SERVICE.validateEmail(this.inputValue)) {
						this.errors.push(this.$i18n.t('projectFormValidations.email'));
					}
				}

				this.hasError = !!this.errors.length;
				this.$emit("hasError", !this.hasError);
			},
			setErrors(errorsList) {
				this.errors = errorsList;
			},
			watchForInvalidSymbols() {
				if (this.type === 'number') {
					let invalidChars = ["-", "+", "e"];
					this.$refs[this.id].addEventListener("keydown", function(e) {
						if (invalidChars.includes(e.key)) {
							e.preventDefault();
						}
					});
				}
			}
		},
		watch: {
			inputValue(newValue) {
				if (this.validationRules.max && newValue.length === this.validationRules.max) {
					this.errors.push(this.$i18n.t('projectFormValidations.maxString', {max: this.validationRules.max}));
				} else {
					this.errors = [];
				}
			}
		},
		mounted() {
			if (this.registerListener) {
				if (this.isManagementListener) {
					EventManagementContent.$on('validateStep', () => {
						this.validateField(true)
					});
				} else {
					EventStepFrom.$on("validateStep", () => {
						this.validateField(true)
					});
				}
			}
			this.watchForInvalidSymbols();
		},
		destroyed() {
			if (this.registerListener) {
				if (this.isManagementListener) {
					EventManagementContent.$off("validateStep");
				} else {
					EventStepFrom.$off("validateStep");
				}
			}
		}
	}
</script>
<style lang="scss" scoped>
.crud-form-group{
	input.crud-input{
		background: #001f33;
		color:white;
		border: 1px solid white;
		border-radius: 4px;
		&:focus{
			outline: none;
			border: 1px solid #00bcd4;
		}
	}
}

</style>
